
import './styles/quasar.scss'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/mdi-v6/mdi-v6.css'

// To be used on app.use(Quasar, { ... })
export default {
    framework: {
        config: {
            notify: {},
            dialog: {}
        },
        plugins: ['Notify', 'Dialog']
    },
    extras: [
        'material-icons',
        'fontawesome-v5',
        'mdi-v6'
    ]
}
